import React, { Component } from 'react';
import {reduxForm} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomAlert from '../components/CustomAlert.js';
import CreditCardMontemar from "./CreditCardMontemar";

class CreditCardForm extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_credit_card" description="Credit Card Info"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveCreditCardForm)} className='pvc-form'>
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <CreditCardMontemar/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Seguir</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

CreditCardForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'last_digits_credit_card', required: true}])

CreditCardForm = TopScrolleable(CreditCardForm);

CreditCardForm = reduxForm({
    form: 'CreditCardForm',
    validate
})(CreditCardForm);

CreditCardForm = withAuthControl(CreditCardForm);

export default CreditCardForm;


/** WEBPACK FOOTER **
 ** ./src/components/CreditCardForm.js
 **/